import { lazy } from '@/service/lazy'

export default [{
  name: 'Usuários do Comercial',
  path: 'relatorio-usuarios-comercial',
  id: 'relatorio-usuarios-comercial',
  icon: 'fa fa-user',
  component: lazy('app/default/relatorios/usuariosativosvendedor/index'),
  meta: { requireAuth: true, rules: [] }
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/usuariosativosvendedor.js